import React, { memo, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchVisits from '../../hooks/visits/useFetchVisits';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import VisitsTable from './VisitsTable';

const VisitsList = () => {
  const navigate = useNavigate();
  const { loading, visits } = useFetchVisits();

  const handleVisitClick = (visit) => {
    navigate(`/vehicles/${visit.vin}/visits/${visit.id}`);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        <VisitsTable onVisitClick={handleVisitClick} visits={visits} />
        {visits.length === 0 && !loading && <EmptyContent title={'Список візитів порожній'} />}
      </div>
    </Suspense>
  );
};

export default memo(VisitsList);
